import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=3cce5124"
import script from "./GlobalMenu.vue?vue&type=script&lang=js"
export * from "./GlobalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports